import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import "../addons.css";
import AuthContext from "../../../contexts/AuthProvider";

import { API_URL } from "../../../utils/config";
const baseUrl = API_URL;

function DeleteFacility({ onClose, facility_id, venue_id }) {
  const { t } = useTranslation("facilty");
  const [isDeleting, setIsDeleting] = useState(false);
const { isAuthenticated } = useContext(AuthContext);
   const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };
  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      if (!isAuthenticated) {
        return;
      }
      const response = await fetch(
        `${baseUrl}/api/v1/attnd-venue/facilities/${facility_id}`,
        {
          method: "DELETE",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            lang: getLangFromLocalStorage(),
          },
        }
      );

      if (!response.ok) {
        throw new Error(t("deleteFacility.errors.deleteFailed"));
      }

      console.log("Facility deleted successfully!");
      onClose();
    } catch (error) {
      console.error("Error deleting the facility:", error);
      alert(t("deleteFacility.errors.deleteFailed"));
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="invite-attendee-modal">
      <div className="delete-modal">
        <button
          className="close-icon"
          onClick={onClose}
          disabled={isDeleting}
        >
          <img src="/x.svg" alt={t("deleteFacility.altClose")} />
        </button>
        <h3 className="delete-heading">{t("deleteFacility.heading")}</h3>
        <p className="delete-desc">{t("deleteFacility.description")}</p>
        <div className="delete-btns">
          <button
            type="button"
            className="cancel-delete"
            onClick={onClose}
            disabled={isDeleting}
          >
            {t("deleteFacility.buttons.cancel")}
          </button>
          <button
            type="button"
            className="addons-delete"
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {isDeleting
              ? t("deleteFacility.buttons.confirm")
              : t("deleteFacility.buttons.confirm")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteFacility;
